/* eslint-disable react/self-closing-comp,no-script-url */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { useHistory } from 'react-router-dom';
import './QuickLinksWidget.scss';

const QuickLinksWidget = () => {
  const history = useHistory();
  return (
    <section className="widget">
      <div className="quick-links-widget">
        <h3 className="title">Quick Links</h3>
        <ul id="menu-quick-links" className="menu clearfix ms-0 ps-0 mt-2">
          <li className="ps-0">
            <a onClick={() => history.push('/buildings/create')}>New Building</a>
          </li>
          <li className="ps-0">
            <a onClick={() => history.push('/instances/building-components/create')}>New Component</a>
          </li>
          <li className="ps-0">
            <a onClick={() => history.push('/instances/building-elements/create')}>New Element</a>
          </li>
          <li className="ps-0">
            <a onClick={() => history.push('/instances/building-products/create')}>New Product</a>
          </li>
          <li className="ps-0">
            <a onClick={() => history.push('/instances/building-contexts/create')}>New Context</a>
          </li>
          <li className="ps-0">
            <a onClick={() => history.push('/instances/building-characteristics/create')}>New Characteristic</a>
          </li>
          <li className="ps-0">
            <a onClick={() => history.push('/building-types')}>Building Types</a>
          </li>
          <li className="ps-0">
            <a onClick={() => history.push('/data-types')}>Data Types</a>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default QuickLinksWidget;
